import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject, transient } from "aurelia-framework";
import {
    GetAssignmentResponse, GetCwSelfAssessmentReviewResponse,
    GetCwsaStatusesRequest as GetCwsaStatusesRequest, GetReviewCriteriaResponse, SetAssignmentRequest,
    SetAssignmentResponse, ChangeCwsaStatus as ChangeCwsaStatusRequest, ChangeCwsaStatusResponse,
    GetCwStatusesResponse
} from "../../models/cwsa/cwsa.models";

@autoinject()
@transient()
export class CwsaService {

    private _crewWelfareApi: string = `${this.configService.config.urls.crewWelfareApiUrl}/api/v1/CrewWelfareSelfAssessmentReview`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    public getCwSelfAssessment(cwSelfAssessmentGuid: string): Promise<GetCwSelfAssessmentReviewResponse> {
        return this.requestClientService.get(`${this._crewWelfareApi}/GetCwSelfAssessment/${cwSelfAssessmentGuid}`, {});
    }

    public getReviewCriteria(cwSelfAssessmentGuid: string): Promise<GetReviewCriteriaResponse> {
        return this.requestClientService.get(`${this._crewWelfareApi}/GetReviewCriteria/${cwSelfAssessmentGuid}`, {});
    }

    public getAssignment(cwSelfAssessmentGuid: string): Promise<GetAssignmentResponse> {
        return this.requestClientService.get(`${this._crewWelfareApi}/GetAssignment/${cwSelfAssessmentGuid}`, {});
    }

    public setAssignment(request: SetAssignmentRequest): Promise<SetAssignmentResponse> {
        return this.requestClientService.post(`${this._crewWelfareApi}/SetAssignment`, {}, request);
    }

    public getCwsaStatuses(request: GetCwsaStatusesRequest): Promise<GetCwStatusesResponse> {
        return this.requestClientService.post(`${this._crewWelfareApi}/GetCwsaStatuses`, {}, request);
    }

    public changeCwsaStatus(request: ChangeCwsaStatusRequest): Promise<ChangeCwsaStatusResponse> {
        return this.requestClientService.post(`${this._crewWelfareApi}/ChangeCwsaStatus`, {}, request);
    }
}
